import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

export const SearchSettingsRadioButtons = ({ value, setValue }) => {
	return (
		<RadioGroup
			row
			value={value}
			onChange={(e) => setValue(e.target.value)}
			sx={{
				"& .MuiRadio-root": {
					padding: "2px",
				},
				"& .MuiFormControlLabel-root": {
					marginLeft: 0,
					marginRight: "6px",
				},
				"& .MuiSvgIcon-root": {
					fontSize: "15px",
				},
				"& .MuiTypography-root": {
					fontSize: "12px",
				},
			}}
		>
			<FormControlLabel value="AND" control={<Radio size="small" />} label="И" />
			<FormControlLabel value="OR" control={<Radio size="small" />} label="ИЛИ" />
		</RadioGroup>
	);
};
